export default {
  namespaced: true,
  log_microservice: {
    title: "microservicio de logs",
    client_host: "host del cliente",
    provider: "proveedor",
    level: "nivel",
    message: "id de mensaje",
    log_message: "mensaje de registro",
    description: "descripción",
    path: "path",
    resource: "recurso",
    target: "dispositivo",
    device: "dispositivo",
    difference: "diferencia",
    tenant_id: "tenant",
    user_id: "usuario",
    action: "acción",
    start_date: "fecha de inicio",
    end_date: "fecha fin",
    loading: "Cargando registros...",
    load_error: "No se pudieron cargar los registros",
    load_error_hint: "Ocurrió un error al consultar el microservicio de logs. Vuelve a intentarlo o ajusta los filtros.",
    The_start_date_value_is_required_for_filter_by_date: "El valor de la fecha de inicio es obligatorio para filtrar por fecha.",
    The_end_date_value_is_required_to_filter_by_date: "El valor de la fecha de finalización es necesario para filtrar por fecha.",
  },
};
